module.exports = __webpack_public_path__ + "static/img/select_bgc.c4111f12.png";